/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionModelConfigFeatureToggleResponse } from '../../models/collection-model-config-feature-toggle-response';

export interface GetConfigFeatureToggles$Params {
  configId: string;
}

export function getConfigFeatureToggles(http: HttpClient, rootUrl: string, params: GetConfigFeatureToggles$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelConfigFeatureToggleResponse>> {
  const rb = new RequestBuilder(rootUrl, getConfigFeatureToggles.PATH, 'get');
  if (params) {
    rb.path('configId', params.configId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionModelConfigFeatureToggleResponse>;
    })
  );
}

getConfigFeatureToggles.PATH = '/config/{configId}/feature-toggles';
